/**
 * Created by mac on 1/20/21
 */

cleverapps.styles.COLORS = cleverapps.overrideColors(cleverapps.styles.COLORS, {
    COLOR_BONUS: new cc.Color(215, 169, 255, 255),
    SHOP_STROKE_COLOR: new cc.Color(0, 0, 0, 100),
    SHOP_SHADOW_COLOR: new cc.Color(0, 0, 0, 80),
    TILE_REWARDS_COLOR: new cc.Color(9, 89, 151, 255),
    YELLOW_TEXT_COLOR: new cc.Color(247, 230, 43, 255),
    LIGHT_TEXT_DISABLED_COLOR: new cc.Color(200, 200, 200, 255),

    WEEKLY_GOALS_PRIMARY_COLOR: new cc.Color(194, 114, 34, 255),
    WEEKLY_GOALS_CLAIM_COLOR: new cc.Color(92, 158, 17, 255),

    GREEN: new cc.Color(123, 194, 63, 255),
    COLOR_RED: new cc.Color(255, 74, 74, 255),

    DARK_TEXT_COLOR: new cc.Color(121, 75, 57, 255),
    DARK_BLUE_TEXT_COLOR: new cc.Color(50, 25, 119, 255),

    "RARITY_COLOR_0": new cc.Color(255, 255, 255, 255),
    "RARITY_COLOR_1": new cc.Color(23, 184, 243, 255),
    "RARITY_COLOR_2": new cc.Color(164, 17, 218, 255),
    "RARITY_COLOR_3": new cc.Color(247, 231, 80, 255),

    WEEKLY_GOALS_DISABLED_COLOR: new cc.Color(230, 230, 230, 255),
    KINGS_CUP_TITLE_COLOR: new cc.Color(255, 234, 0, 255)
});

cleverapps.overrideStyles(cleverapps.styles.UI.Button, {
    keepRadius: true
});

cleverapps.overrideStyles(cleverapps.styles.UI.Avatar, {
    x: 11,
    top: 11,
    bottom: 11
});

(function () {
    [
        cleverapps.styles.UI.Button.Images.button_green,
        cleverapps.styles.UI.Button.Images.button_blue,
        cleverapps.styles.UI.Button.Images.button_red,
        cleverapps.styles.UI.Button.Images.button_purple,
        cleverapps.styles.UI.Button.Images.small_button_blue,
        cleverapps.styles.UI.Button.Images.small_button_green,
        cleverapps.styles.UI.Button.Images.field_button_green,
        cleverapps.styles.UI.Button.Images.field_button_blue
    ].forEach((obj) => {
        cleverapps.overrideStyles(obj, {
            SKIP_RESOLUTION: {
                padding: {
                    left: 0.3,
                    right: 0.3,
                    top: 0.05,
                    bottom: 0.12
                }
            }
        });
    });
}());

(function () {
    [
        cleverapps.styles.UI.Button.Images.settings_control_button,
        cleverapps.styles.UI.Button.Images.settings_control_red_button
    ].forEach((obj) => {
        cleverapps.overrideStyles(obj, {
            button_off_png: bundles.buttons.frames.button_png,
            SKIP_RESOLUTION: {
                padding: {
                    top: 0.05,
                    bottom: 0.12
                }
            }
        });
    });
}());

cleverapps.overrideStyles(cleverapps.styles.DECORATORS, {
    LIGHT_TEXT_STROKE: {
        color: cleverapps.styles.COLORS.LIGHT_TEXT_STROKE_COLOR,
        size: 1
    },

    LIGHT_TEXT_SHADOW: {
        color: cleverapps.styles.COLORS.LIGHT_TEXT_SHADOW_COLOR,
        direction: cc.size(0, -2),
        blur: 3
    },

    SHOP_STROKE: {
        color: cleverapps.styles.COLORS.SHOP_STROKE_COLOR,
        size: 1
    },

    SHOP_SHADOW: {
        color: cleverapps.styles.COLORS.SHOP_SHADOW_COLOR,
        direction: cc.size(0, -2),
        blur: 3
    },

    TITLE_TEXT_SHADOW: {
        color: cleverapps.styles.COLORS.TITLE_SHADOW,
        direction: cc.size(0, -2),
        blur: 1
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    LIGHTNING_RUSH_TITLE_TEXT: {
        size: 90,
        color: new cc.Color(255, 234, 0, 255),
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    LIGHTNING_RUSH_TIMER_TEXT: {
        name: "nostroke",
        size: 42,
        color: new cc.Color(255, 220, 132, 255)
    },

    TIMER_TEXT: {
        name: "default",
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    BOOSTER_BEFORE_AMOUNT_TEXT: {
        name: "default",
        size: 35
    },

    ROW_PLAYER_TEXT: {
        name: "nostroke",
        size: 40,
        color: new cc.Color(42, 83, 170, 255)
    },

    ROW_TEXT: {
        name: "nostroke",
        size: 40,
        color: new cc.Color(164, 72, 64, 255)
    },

    ROW_SCORE_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    MENUBAR_TEXT: {
        name: "nostroke",
        size: 55,
        color: cleverapps.styles.COLORS.WHITE
    },

    MENUBAR_TIMER_TEXT: {
        name: "nostroke",
        size: 34,
        color: new cc.Color(76, 211, 250, 255)
    },

    MENUBAR_PROGRESS_TEXT: {
        size: 39
    },

    MENUBAR_LEVEL_WITH_AVATAR_TEXT: {
        size: 38
    },

    TILE_SHOP_OFFER_TEXT: {
        name: "default",
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.SHOP_STROKE,
        size: 45
    },

    TILE_SHOP_COINS_OFFER: {
        name: "default",
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.SHOP_STROKE,
        size: 60
    },

    SHOP_WINDOW_SMALL_TILE_TITLE: {
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.SHOP_STROKE,
        shadow: cleverapps.styles.DECORATORS.SHOP_SHADOW
    },

    SHOP_LIVES_PRODUCT_TILE_DESCRIPTION_TEXT: {
        name: "nostroke",
        size: 32,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    TILE_REWARDS: {
        size: 40,
        name: "nostroke",
        color: cleverapps.styles.COLORS.TILE_REWARDS_COLOR
    },

    TILE_REWARDS_HEADER: {
        size: 30,
        name: "nostroke",
        color: cleverapps.styles.COLORS.TILE_REWARDS_COLOR
    },

    SHOP_WINDOW_TILE_TITLE: {
        name: "default",
        size: 55,
        color: cleverapps.styles.COLORS.WHITE
    },

    PRODUCT_TILE_LIMIT_TEXT: {
        name: "nostroke",
        size: 26,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },
    SHOP_WINDOW_LIVES_TEXT: {
        name: "nostroke",
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        size: 40
    },

    TILE_SHOP_BADGE_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TILE_SHOP_BADGE_STROKE
    },

    PACK_TILE_REWARDS_TEXT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    WINDOW_TITLE_TEXT: {
        size: 68,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_3PX
    },

    NOBG_WINDOW_TITLE_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_3PX
    },

    WINDOW_SMALL_TEXT: {
        name: "nostroke",
        size: 30,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },
    TOURNAMENT_PLAYER_TEXT: {
        name: "nostroke",
        size: 30,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },
    WINDOW_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },
    EXTRA_WINDOW_TEXT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },
    LOADING_ANIMATION_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },
    FBCONNECT_WINDOW_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },
    TERMS_WINDOW_TEXT: {
        size: 28,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    LIGHT_TITLE_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },
    LIGHT_TITLE_TEXT_DISABLED: {
        size: 50,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_DISABLED_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    UNIT_PROB: {
        size: 35,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    FORCE_MESSAGE_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    DIALOGUE_MESSAGE_TEXT: {
        size: 55,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    LIGHT_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    DARK_TEXT: {
        name: "nostroke",
        size: 45,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    LOADING_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    REWARDS_LIST_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR
    },

    REWARD_WINDOW_REWARDS_TEXT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    SIDEBAR_ICON_TEXT: {
        name: "default",
        size: 38,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    EXPEDITION_WINDOW_TEXT: {
        size: 32,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },
    CHAT_REWARD_COUNT_TEXT: {
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },
    RATE_WINDOW_TEXT: {
        size: 60,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    FRIEND_REQUEST_TEXT: {
        name: "nostroke",
        size: 35,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    DIALOGUE_PERSON_TITLE_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    KNOCKOUT_WINDOW_COUNTDOWN_TEXT: {
        name: "nostroke",
        size: 70,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    COOLDOWNNODE_TIMER_TEXT: {
        name: "nostroke",
        size: 65,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    CLANS_ROW_LEADER_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    SUBSCRIPTION_BUTTON_TITLE: {
        size: 22,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_DISABLED_COLOR,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    SUBSCRIPTION_MAIN_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    TERMS_LINK_TEXT: {
        size: 26,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    TERMS_TEXT: {
        size: 22,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_DISABLED_COLOR,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    VIPREWARDEDWINDOW_DESCRIPTION_TEXT: {
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    VIPREWARDEDWINDOW_TIMER_TEXT: {
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    VIPREWARDEDWINDOW_NOTE_TEXT: {
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    LEVEL_TITLE_TEXT: {
        name: "nostroke",
        size: 65,
        color: new cc.Color(48, 83, 120, 255)
    },

    LEVEL_CURRENT_TITLE_TEXT: {
        size: 40
    },

    LEVEL_NOT_PASSED_TITLE_TEXT: {
        name: "nostroke",
        size: 40,
        color: new cc.Color(58, 58, 58, 255)
    },

    PROLONG_BUTTON_AMOUNT_TEXT: {
        size: 32,
        color: cleverapps.styles.COLORS.WHITE
    },

    SHOP_USER_GOLD_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    PRIZE_CALENDAR_TITLE: {
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    NOADS_BONUS_TEXT: {
        name: "nostroke"
    },

    PRIZE_BAR_TEXT: {
        size: 40
    },

    STAR_CHEST_PROGRESS_TEXT: {
        size: 35
    },

    UNITSSHOP_CART_AMOUNT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        stroke: undefined,
        shadow: undefined
    },

    UNITFAMILY_TITLE: {
        size: 50,
        color: new cc.Color(161, 80, 37, 255),
        stroke: undefined,
        shadow: undefined
    },

    HERODETAILS_TEXT: {
        size: 40,
        color: new cc.Color(161, 80, 37, 255),
        stroke: undefined,
        shadow: undefined
    },

    SETTINGS_WINDOW_NAME_TEXT: {
        name: "nostroke",
        size: 43,
        color: cleverapps.styles.COLORS.SETTINGS_WINDOW_TEXT_COLOR
    },

    SETTINGS_WINDOW_FOLLOW_US_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.SETTINGS_WINDOW_TEXT_COLOR
    },

    SETTINGS_WINDOW_VERSION_TEXT: {
        name: "nostroke",
        size: 33,
        color: cleverapps.styles.COLORS.SETTINGS_WINDOW_TEXT_COLOR
    },

    WEEKLY_GOALS_POINTS_TEXT: {
        color: cleverapps.styles.COLORS.WEEKLY_GOALS_PRIMARY_COLOR
    },
    WEEKLY_GOALS_BAR_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.WEEKLY_GOALS_PRIMARY_COLOR
    },
    WEEKLY_GOALS_REWARD_TEXT: {
        color: cleverapps.styles.COLORS.WEEKLY_GOALS_PRIMARY_COLOR
    },
    WEEKLY_GOALS_TITLE_TEXT: {
        color: cleverapps.styles.COLORS.WEEKLY_GOALS_PRIMARY_COLOR
    },
    WEEKLY_GOALS_DAY_TEXT: {
        color: cleverapps.styles.COLORS.WEEKLY_GOALS_PRIMARY_COLOR
    },
    KINGS_CUP_TITLE_TEXT: {
        color: cleverapps.styles.COLORS.KINGS_CUP_TITLE_COLOR
    }
});

cleverapps.overrideStyles(cleverapps.styles.Timer, {
    width: 270,
    timer: {
        y: { align: "center", dy: 2 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.NotificationView, {
    progress: {
        progressFrames: {
            0: bundles.progress_bar.frames.bar_red,
            30: bundles.progress_bar.frames.bar_orange,
            70: bundles.progress_bar.frames.bar_green
        },
        height: 44
    }
});

cleverapps.overrideStyles(cleverapps.styles.PrizeBarComponent, {
    prize: {
        flyY: 10,
        x: { align: "right", dx: 50 },
        y: { align: "center", dy: 8 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.MenuBarItem, {
    bg: {
        width: 270,
        height: 68,
        timerHeight: 100,
        minWidth: 247,
        padding: {
            right: 16,
            top: 0,
            bottom: 2
        }
    },

    text: {
        dx: -5
    },

    items: {
        GoldItem: {
            icon: {
                scale: 1.1,
                x: 28
            },

            plusButton: {
                offset: {
                    x: -19,
                    y: -3
                }
            }
        },

        CoinsItem: {
            icon: {
                scale: 1.15
            }
        },

        LivesItem: {
            icon: {
                scale: 1.07
            },

            plusButton: {
                offset: {
                    x: -10,
                    y: -3
                }
            }
        },

        WandsItem: {
            icon: {
                scale: 1.05
            }
        },

        WorkersItem: {
            bg: {
                width: 291
            },

            icon: {
                scale: 1.25
            }
        },

        OrderStarsItem: {
            icon: {
                scale: 1.05
            }
        }
    },

    icon: {
        x: 15,
        y: 0
    },

    plusButton: {
        scale: 1.05,
        offset: {
            x: -15,
            y: -3
        }
    },

    iconText: {
        position: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 6 }
        }
    },

    attention: {
        scale: 0.85,
        x: { align: "right", dx: 15 },
        y: { align: "bottom", dy: -15 }
    },

    timer: {
        x: { align: "center", dx: 16 },
        y: { align: "bottom", dy: 8 }
    },

    premiumSticker: {
        y: { align: "center", dy: 45 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.MenuBarTextView, {
    amountText: {
        dy: 3
    }
});

if (cleverapps.styles.AvatarMenuBarView) {
    cleverapps.overrideStyles(cleverapps.styles.AvatarMenuBarView, {
        height: 91,

        level: {
            x: { align: "left", dx: -20 },
            y: { align: "bottom", dy: -17 },
            scale: [1.25, 1, 1],
            text: {
                x: { align: "center", dx: -1 },
                y: { align: "center", dy: -5 }
            },

            collections: {
                x: { align: "left", dx: -15 },
                y: { align: "bottom", dy: -36 },
                text: {
                    x: { align: "center", dx: -1 },
                    y: { align: "center", dy: 5 }
                }
            }
        },

        avatar: {
            x: { align: "center" },
            y: { align: "top" },

            size: {
                width: 185,
                height: 195
            },

            mobileSize: [{
                width: 163,
                height: 173
            }, {
                width: 185,
                height: 195
            }, {
                width: 185,
                height: 195
            }],

            padding: 0
        },

        progress: {
            x: { align: "center", dx: 20 },
            y: { align: "bottom", dy: -2 },

            width: 130,
            mobileWidth: [117, 130, 130]
        },

        toolTipContent: {
            margin: 20
        }
    });
}

if (cleverapps.styles.QuestsTableView) {
    cleverapps.overrideStyles(cleverapps.styles.QuestsTableView, {
        size: {
            width: 210,
            height: 610
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.RowView, {
    width: 1030,
    height: 116,

    paddingX: 40,

    place: {
        withBadge: {
            width: 50
        },

        width: 50
    },

    content: {
        height: 94,
        y: { align: "center", dy: 3 }
    },

    name: {
        x: { align: "left" }
    },

    prize: {
        width: 100,
        verticalWidth: 100
    },

    score: {
        width: 160,
        verticalWidth: 140,
        height: 64
    }
});

cleverapps.overrideStyles(cleverapps.styles.DefaultTableStyles, {
    margin: -6
});

cleverapps.overrideStyles(cleverapps.styles.FriendRequestView, {
    width: 580,
    height: 230,

    processButton: {
        height: 70,
        x: 50
    },

    Avatar: {
        Margin: {
            x: 50
        }
    },

    Icon: {
        x: 267
    },

    Request: {
        width: 300
    },

    close: {
        x: 28,
        y: 12
    }
});

cleverapps.overrideStyles(cleverapps.styles.FriendRequestsWindow, {
    y: 150
});

cleverapps.overrideStyles(cleverapps.styles.LevelStartWindow, {
    padding: {
        top: 20,
        bottom: 5
    },

    lanternStart: {
        margin: 20,
        padding: {
            left: -30,
            right: -30,
            bottom: 5
        },

        coinBadge: {
            label: {
                anchor: { x: 0.5, y: 0.5 },
                x: { align: "center", dx: 0 },
                y: { align: "center", dy: 0 }
            },
            x: { align: "left", dx: 97 },
            y: { align: "top", dy: -88 }
        }
    }
});
if (cleverapps.config.type === "match3") {
    cleverapps.overrideStyles(cleverapps.styles.LevelStartWindow, {
        hardLevel: {
            x: { align: "left", dx: 30 },
            y: { align: "top" }
        }
    });
}

if (cleverapps.styles.HardLevelWindowIcon) {
    cleverapps.overrideStyles(cleverapps.styles.HardLevelWindowIcon, {
        rotation: 0
    });
}

if (cleverapps.styles.BoosterBeforeView) {
    cleverapps.overrideStyles(cleverapps.styles.BoosterBeforeView, {
        textAvailable: {
            y: { align: "bottom", dy: 9 },

            bg: {
                y: { align: "bottom", dy: -15 },
                height: 70
            }
        }
    });
}

if (cleverapps.styles.BoosterBeforeAmountView) {
    cleverapps.overrideStyles(cleverapps.styles.BoosterBeforeAmountView, {
        amount: {
            y: { align: "center", dy: 2 }
        }
    });
}

if (cleverapps.styles.BoostersBeforeComponent) {
    cleverapps.overrideStyles(cleverapps.styles.BoostersBeforeComponent, {
        contentMargin: 30
    });
}

cleverapps.overrideStyles(cleverapps.styles.SelectFriendWindow, {
    withFriends: {
        height: 730
    }
});

cleverapps.overrideStyles(cleverapps.styles.LoseWindow, {
    livesLeftMargin: 0,
    animation: {
        width: 400,
        height: 400
    },
    content: {
        padding: {
            top: 20,
            bottom: 10,
            x: 30
        }
    },

    life: {
        width: 80,
        height: 60
    },
    livesLeftText: {
        width: 500
    }
});

cleverapps.overrideStyles(cleverapps.styles.RestartWindow, {
    button: {
        width: 220,
        height: 90
    }
});

if (cleverapps.styles.HeroWindow) {
    cleverapps.overrideStyles(cleverapps.styles.HeroWindow, {
        padding: {
            bottom: 70
        },

        helpBlock: {
            text: {
                width: 400
            }
        }
    });
}

if (cleverapps.styles.ExtraWindow) {
    cleverapps.overrideStyles(cleverapps.styles.ExtraWindow, {
        margin: 40,
        window: {
            padding: {
                left: 30,
                top: 80,
                right: 30,
                bottom: 80
            },
            CloseButton: {
                x: { align: "right", dx: 30 },
                y: { align: "top", dy: 30 }
            }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.DialogueViewHorizontal, {
    widthPadding: 50,
    offsetY: 10,

    positions: {
        bottom: {
            y: 30
        }
    },

    arrow: {
        y: { align: "top", dy: 36 }
    },

    text: {
        padding: {
            fromWallX: 60,
            x: 60,
            y: 50
        },
        verticalPadding: {
            fromWallX: 60,
            x: 60,
            y: 45
        }
    },

    title: {
        offsetX: 50,
        mobileY: { align: "top", anchor: false, dy: -5 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.MinimalDialogue, {
    text: {
        arrow: {
            left: {
                x: { align: "left", dx: -21 },
                y: { align: "center", dy: 0 }
            },
            right: {
                x: { align: "right", dx: 23 },
                y: { align: "center", dy: 0 }
            }
        },

        verticalPadding: {
            top: 20,
            bottom: 18,
            left: 25,
            right: 25
        }
    }
});

if (cleverapps.styles.ProlongationOfferView) {
    cleverapps.overrideStyles(cleverapps.styles.ProlongationOfferView, {
        label: {
            amount: {
                x: { align: "center", dx: -3 },
                y: { align: "center", dy: -15 }
            }
        },

        bonusLabel: {
            x: { align: "center", dx: 145 },
            y: { align: "center", dy: 73 }
        }
    });
}

if (cleverapps.styles.BackgroundsWindow) {
    cleverapps.overrideStyles(cleverapps.styles.BackgroundsWindow, {
        padding: {
            right: -45,
            left: -45
        },
        present: {
            button: {
                x: { align: "center", dx: 10 }

            }
        },

        tape: {
            x: { align: "right", dx: 31 },
            withName: {
                x: { align: "right", dx: 31 }
            },
            text: {
                y: 65
            }
        },

        item: {
            bg: {
                padding: {
                    x: 10,
                    y: 12
                }
            }
        },

        lockWithName: {
            x: { align: "center" },
            y: { align: "center", dy: 0 }
        },

        name: {
            x: { align: "center" },
            y: { align: "top", dy: -30 }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.TileBadge, {
    x: { align: "center", dx: -3 },
    y: { align: "center", dy: 3 },
    height: 112
});

if (cleverapps.styles.StarsProgressBar) {
    cleverapps.overrideStyles(cleverapps.styles.StarsProgressBar, {
        bar: {
            offsetX: 6,
            height: 82,
            dy: 5
        },

        barAnimation: {
            offsetX: -15
        }
    });
}

if (cleverapps.styles.StarChestWindow) {
    cleverapps.overrideStyles(cleverapps.styles.StarChestWindow, {
        bar: {
            type: ScaledProgressBar.Types.green
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.SubscriptionButtons, {
    buttonWidth: 410,
    buttonHeight: 120
});

cleverapps.overrideStyles(cleverapps.styles.CloseButton, {
    position: [{
        x: { align: "right", dx: 18 },
        y: { align: "top", dy: 18 }
    }, {
        x: { align: "right", dx: 30 },
        y: { align: "top", dy: 30 }
    }, {
        x: { align: "right", dx: 30 },
        y: { align: "top", dy: 30 }
    }]
});

cleverapps.overrideStyles(cleverapps.styles.Window, {
    border: {
        x: 28,
        top: 28,
        bottom: 32
    },
    padding: {
        x: 55,
        top: 40,
        bottom: 40
    },

    Background: {
        padding: {
            x: 5,
            y: 20
        }
    },
    HelpButton: {
        lovesTitle: true
    }
});

cleverapps.overrideStyles(cleverapps.styles.Tabs, {
    buttons: {
        width: 135,
        height: 240
    },

    attention: {
        x: { align: "left", dx: -20 },
        y: { align: "top", dy: -20 }
    },

    margin: 6
});

cleverapps.overrideStyles(cleverapps.styles.RateWindow, {
    width: 800,
    height: 400,

    text: {
        height: 400
    }
});

cleverapps.overrideStyles(cleverapps.styles.WindowTitle.Types, {
    bg_window: {
        scale: [0.8, 1, 1],
        background: {
            height: 103,
            padding: {
                x: 50
            }
        },
        titleSideOffset: {
            x: 130
        },
        text: {
            y: { align: "center", dy: 6 }
        },
        position: {
            y: { align: "top", anchor: false, dy: -9 }
        },
        helpButton: {
            x: { align: "left", dx: 30 }
        }
    },
    nobg_window: {
        background: {
            padding: {
                x: 145
            }
        }
    }
});

if (cleverapps.styles.ExtendUnlimitedLivesWindow) {
    cleverapps.overrideStyles(cleverapps.styles.ExtendUnlimitedLivesWindow, {
        animation: {
            height: 200
        }
    });
}

if (cleverapps.styles.DailyCupView) {
    cleverapps.overrideStyles(cleverapps.styles.DailyCupView, {
        title: {
            text: {
                width: 430,

                y: { align: "center", dy: -18 }
            }
        }
    });
}

if (cleverapps.styles.LocationView) {
    cleverapps.overrideStyles(cleverapps.styles.LocationView, {
        coming_soon: {
            activities: {
                button: {
                    height: 80
                }
            }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.SettingsWindow, {
    text: {
        size: [{ width: 300 }, { width: 780 }, { width: 780 }]
    },

    info: {
        position: [{
            x: { align: "left", dx: 194 },
            y: { align: "center" }
        }, {
            x: { align: "left", dx: 210 },
            y: { align: "center" }
        }, {
            x: { align: "left", dx: 210 },
            y: { align: "center" }
        }]
    },

    user: {
        padding: {
            top: 15,
            bottom: 30
        }
    },

    grid: {
        margin: {
            y: 25
        }
    },

    controlButton: {
        width: 130,
        height: 110
    },

    avatar: {
        position: {
            x: { align: "left", dx: 30 },
            y: { align: "center" }
        },

        padding: {
            top: 0,
            bottom: 0,
            right: 0,
            left: 0
        },

        size: {
            width: 150,
            height: 150
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.DeleteAccountWindow, {
    window: {
        padding: {
            left: 50,
            right: 50,
            top: 60,
            bottom: 70
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.DialoguePersonTitleView, {
    text: {
        y: { align: "center", dy: 3 },
        padding: {
            x: 85,
            y: -20
        }
    }
});

if (cleverapps.styles.PackOfferComponent && cleverapps.styles.PackOfferComponent[Offers.TYPES.STICKERS_PACK]) {
    cleverapps.overrideStyles(cleverapps.styles.PackOfferComponent[Offers.TYPES.STICKERS_PACK], {
        pack: {
            badge: {
                x: { align: "right", dx: -50 },
                y: { align: "top", dy: 65 },
                rotation: 30
            },
            packOverlap: 1,
            title: undefined
        },
        tap: {
            x: { align: "center", dx: -20 },
            y: { align: "center", dy: -110 },
            rotation: 0
        }
    });
}

if (cleverapps.styles.PackOfferComponent && cleverapps.styles.PackOfferComponent[Offers.TYPES.KRAKENFEAST]) {
    cleverapps.overrideStyles(cleverapps.styles.PackOfferComponent[Offers.TYPES.KRAKENFEAST], {
        pack: {
            offsetX: 500,
            offsetY: 280,

            title: {
                x: { align: "center", dx: 225 },
                y: { align: "center", dy: -92 }
            }
        },

        tap: {
            x: { align: "center", dx: -575 },
            y: { align: "center", dy: 317 }
        }
    });
}

if (cleverapps.styles.PrizeCalendarWindow) {
    cleverapps.overrideStyles(cleverapps.styles.PrizeCalendarWindow, {
        margin: 30,
        windowPadding: {
            bottom: 15,
            x: -10
        },
        tiles: {
            margin: {
                x: 55, y: 83
            },
            padding: {
                y: 15
            }
        }
    });

    cleverapps.overrideStyles(cleverapps.styles.ActiveCalendarTileComponent, {
        titleBg: {
            y: { align: "center", dy: 0 }
        },

        adIcon: {
            x: { align: "right", dx: 50 },
            y: { align: "bottom", dy: -50 }
        }
    });

    cleverapps.overrideStyles(cleverapps.styles.PrizeCalendarTileView, {
        rewards: {
            x: { align: "center" },
            y: { align: "center", dy: -10 },

            fitToBox: {
                width: 120,
                height: 120,

                maxScale: 1
            }
        },
        mark: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: -37 }
        }
    });
}

if (cleverapps.styles.QuestIcon) {
    cleverapps.overrideStyles(cleverapps.styles.QuestIcon, {
        progress: {
            y: { align: "bottom", dy: -5 },
            width: 160,
            height: 55,
            text: {
                y: { align: "center", dy: 2 }
            }
        }
    });
}

if (cleverapps.styles.QuestInfoView) {
    cleverapps.overrideStyles(cleverapps.styles.QuestInfoView, {
        regular: {
            title: {
                width: 614
            },

            arrow: {
                x: { align: "left", dx: -29 }
            }
        },

        compact: {
            arrow: {
                x: { align: "left", dx: -29 }
            }
        }
    });
}

if (cleverapps.styles.OpenLetterButtonBooster) {
    cleverapps.overrideStyles(cleverapps.styles.OpenLetterButtonBooster, {
        width: 150,
        height: 120,
        position: [
            { x: { align: "left", dx: 15 }, y: { align: "bottom", dy: 350 } },
            { x: { align: "right", dx: -10 }, y: { align: "bottom", dy: 450 } },
            { x: { align: "right", dx: -10 }, y: { align: "bottom", dy: 450 } }
        ],
        content: {
            margin: -5,
            direction: cleverapps.UI.VERTICAL,
            layout: {
                y: { align: "center", dy: 20 }
            }
        }
    });
}

if (cleverapps.styles.CustomerIngredientViewInfoView) {
    cleverapps.overrideStyles(cleverapps.styles.CustomerIngredientViewInfoView, {
        bg: {
            width: 76,
            height: 76,
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 1 }
        }
    });
}

if (cleverapps.styles.HintButtonBooster) {
    cleverapps.overrideStyles(cleverapps.styles.HintButtonBooster, {
        width: 150,
        height: 120,
        position: [
            { x: { align: "right", dx: -15 }, y: { align: "bottom", dy: 350 } },
            { x: { align: "right", dx: -10 }, y: { align: "bottom", dy: 300 } },
            { x: { align: "right", dx: -10 }, y: { align: "bottom", dy: 300 } }
        ],
        content: {
            margin: -7,
            direction: cleverapps.UI.VERTICAL,
            layout: {
                y: { align: "center", dy: 20 }
            }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.UI.Tooltip, {
    content: {
        offset: {
            y: 2
        }
    }
});

if (cleverapps.styles.UnitsLibraryWindow) {
    cleverapps.overrideStyles(cleverapps.styles.UnitsLibraryWindow, {
        withTitle: true,

        size: [{
            width: 960,
            height: 1200
        }, {
            width: 1406,
            height: 960
        }, {
            width: 1406,
            height: 960
        }],

        tabs: {
            position: [{
                x: { align: "left", dx: 40 },
                y: { align: "bottom", dy: -149 }
            }, {
                x: { align: "left", dx: 60 },
                y: { align: "bottom", dy: -134 }
            }, {
                x: { align: "left", dx: 60 },
                y: { align: "bottom", dy: -134 }
            }],
            direction: cleverapps.UI.HORIZONTAL,
            type: Tabs.Types.tabs_bottom,
            size: [{
                width: 148,
                height: 152
            }, {
                width: 214,
                height: 137
            }, {
                width: 214,
                height: 137
            }],
            margin: [{ margin: -5 }, { margin: -5 }, { margin: -5 }],
            iconMaxScale: [1.2, 1, 1],
            changeIconColor: false,
            changeIconOpacity: true,

            moveUpSelected: true,
            selectAnimation: "base",

            attention: {
                x: { align: "left", dx: 10 },
                y: { align: "bottom", dy: -15 }
            },

            padding: [{
                bottom: 10,
                top: 32
            }, {
                bottom: 10,
                top: 24
            }, {
                bottom: 10,
                top: 24
            }]
        },

        padding: {
            x: 40
        }
    });
}

if (cleverapps.styles.UnitLibraryIcon) {
    cleverapps.overrideStyles(cleverapps.styles.UnitLibraryIcon, {
        footer: false
    });
}

if (cleverapps.styles.UnitLibraryIconBg) {
    cleverapps.overrideStyles(cleverapps.styles.UnitLibraryIconBg, {
        title: false,

        prize: {
            x: { align: "center" },
            y: { align: "center", dy: 0 }
        },

        iconUnknown: {
            x: { align: "center" },
            y: { align: "center", dy: 0 }
        },

        nextArrow: {
            x: { align: "right", dx: 12 },
            y: { align: "center", dy: 0 }
        }
    });
}

if (cleverapps.styles.FamilyLayout) {
    cleverapps.overrideStyles(cleverapps.styles.FamilyLayout, {
        background: false,

        title: {
            x: { align: "center" },
            y: { align: "top", dy: 0 },

            decorMargin: 30,

            opacity: 150
        },

        grid: {
            position: {
                x: { align: "left", dx: 0 },
                y: { align: "center", dy: 0 }
            },

            padding: {
                x: 20,
                top: 90,
                bottom: 20
            },

            separator: false
        }
    });
}

if (cleverapps.styles.UnitsTab) {
    cleverapps.overrideStyles(cleverapps.styles.UnitsTab, {
        margin: 10,
        padding: {
            x: 0,
            y: 40
        },

        separator: {
            width: 1000
        }
    });
}

if (cleverapps.styles.HeroDetailsLayout) {
    cleverapps.overrideStyles(cleverapps.styles.HeroDetailsLayout, {
        height: 300,

        buttonInfo: [{
            x: { align: "left", dx: 164 },
            y: { align: "top", dy: -64 }
        }, {
            x: { align: "left", dx: 184 },
            y: { align: "top", dy: -64 }
        }, {
            x: { align: "left", dx: 184 },
            y: { align: "top", dy: -64 }
        }],

        title: {
            x: { align: "center", dx: 120 },
            y: { align: "top", dy: 0 }
        },

        grid: {
            size: [{ width: 686 }, { width: 1076 }, { width: 1076 }],

            position: [{
                x: { align: "left", dx: 240 },
                y: { align: "bottom", dy: 10 }
            }, {
                x: { align: "left", dx: 260 },
                y: { align: "bottom", dy: 10 }
            }, {
                x: { align: "left", dx: 260 },
                y: { align: "bottom", dy: 10 }
            }],

            scroll: [{
                x: { align: "left", dx: 240 },
                y: { align: "bottom", dy: 10 }
            }, {
                x: { align: "left", dx: 260 },
                y: { align: "bottom", dy: 10 }
            }, {
                x: { align: "left", dx: 260 },
                y: { align: "bottom", dy: 10 }
            }],

            margin: {
                x: 44,
                y: 20
            },

            padding: {
                x: 20,
                top: 20,
                bottom: 20
            }
        },

        heroIcon: {
            position: [{
                x: { align: "left", dx: 0 },
                y: { align: "bottom", dy: 20 }
            }, {
                x: { align: "left", dx: 20 },
                y: { align: "bottom", dy: 20 }
            }, {
                x: { align: "left", dx: 20 },
                y: { align: "bottom", dy: 20 }
            }]
        }
    });
}

if (cleverapps.styles.HeroIcon) {
    cleverapps.overrideStyles(cleverapps.styles.HeroIcon, {
        icon: {
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: 18 },
            scale: 0.8
        }
    });
}

if (cleverapps.styles.TravelMapBuildingView) {
    cleverapps.overrideStyles(cleverapps.styles.TravelMapBuildingView, {
        bar: {
            width: 150,
            x: { align: "center", dx: 4 },
            y: { align: "center", dy: 8 }
        },

        barSubstrate: {
            x: { align: "center" },
            y: { align: "top", dy: 116 },
            width: 250,
            height: 120,

            bottomPosition: {
                x: { align: "center" },
                y: { align: "bottom", dy: -176 }
            },

            corner: {
                x: { align: "center" },
                y: { align: "bottom", dy: -4 },
                bottomPosition: {
                    x: { align: "center" },
                    y: { align: "top", dy: 10 }
                }
            }
        }
    });
}

if (cleverapps.styles.IslandDecorationStartWindowOctober) {
    cleverapps.overrideStyles(cleverapps.styles.IslandDecorationStartWindowOctober, {
        size: {
            width: 985,
            height: 645
        },

        picture: {
            x: { align: "center", dx: 0 },
            y: { align: "top", dy: -17 }
        },

        text: {
            width: 990,
            height: 110,

            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: 0 }
        },

        label: false,

        button: {
            width: 475
        },

        window: {
            padding: {
                bottom: 40
            }
        },

        timer: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: -145 },
            width: 235
        }
    });
}

if (cleverapps.styles.IslandDecorationStartWindowNovember) {
    cleverapps.overrideStyles(cleverapps.styles.IslandDecorationStartWindowNovember, {
        size: {
            width: 985,
            height: 645
        },

        picture: {
            x: { align: "center", dx: 0 },
            y: { align: "top", dy: -17 }
        },

        text: {
            width: 990,
            height: 110,

            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: 0 }
        },

        label: false,

        button: {
            width: 475
        },

        window: {
            padding: {
                bottom: 40
            }
        },

        timer: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: -145 },
            width: 235
        }
    });
}

if (cleverapps.styles.IslandDecorationStartWindowDecember) {
    cleverapps.overrideStyles(cleverapps.styles.IslandDecorationStartWindowDecember, {
        size: {
            width: 985,
            height: 645
        },

        picture: {
            x: { align: "center", dx: 0 },
            y: { align: "top", dy: -17 }
        },

        text: {
            width: 990,
            height: 110,

            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: 0 }
        },

        label: false,

        button: {
            width: 475
        },

        window: {
            padding: {
                bottom: 40
            }
        },

        timer: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: -145 },
            width: 235
        }
    });
}

if (cleverapps.styles.IslandDecorationStartWindowJanuary) {
    cleverapps.overrideStyles(cleverapps.styles.IslandDecorationStartWindowJanuary, {
        size: {
            width: 985,
            height: 645
        },

        picture: {
            x: { align: "center", dx: 0 },
            y: { align: "top", dy: -17 }
        },

        text: {
            width: 990,
            height: 110,

            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: 0 }
        },

        label: false,

        button: {
            width: 475
        },

        window: {
            padding: {
                bottom: 40
            }
        },

        timer: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: -145 },
            width: 235
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.RewardWindow, {
    rewardChest: {
        delay: 0.3
    }
});

cleverapps.overrideStyles(cleverapps.styles.UI.ImageFont, {
    SKIP_RESOLUTION: {
        DESCENTS: {
            "fonts/comichelvetic": 0.12,
            "fonts/comichelvetic-nostroke": 0.06
        }
    },
    lettersOffset: {
        "fonts/comichelvetic-nostroke": -11,
        "fonts/comichelvetic": -13
    }
});

if (cleverapps.styles.LevelUpWindow) {
    cleverapps.overrideStyles(cleverapps.styles.LevelUpWindow["default"], {
        width: 1100,
        height: 1168
    });
}
